import { jsxs as C, jsx as l } from "react/jsx-runtime";
import P from "clsx";
import { useContext as B } from "react";
import { C as S, a2 as L, a3 as R, m as d, F as $, S as j } from "./helpers-458d7e27.js";
import { S as A } from "./SplitSectionItem-5efb0099.js";
import { jsx as w, css as h } from "@emotion/react";
import "@paypalcorp/pp-react-theme";
import "@paypalcorp/pp-react-icons";
import "react-dom";
import "./TextGroup-dd19925e.js";
import "./AppDownload-79ac7787.js";
import "./pp-react-text-input.esm-853a9847.js";
import "./card-renderer-3ad4b108.js";
import "./PpReactCurrencyInput-cfa9b61d.js";
const g = "SplitGraphicBackground", T = new S(g), v = ({
  backgroundAsset: i,
  ariaHidden: s,
  ...o
}) => {
  var a;
  const e = (a = o.graphicVersion) != null && a.includes("Left") ? "left: 0; right: unset;" : "right: 0; left: unset;", { image: t } = i || {};
  return /* @__PURE__ */ w(
    L,
    {
      className: T.getComponentClassName(),
      css: h`
        position: absolute;
        width: 100%;
        overflow: hidden;
        top: 0;
        --height: 100vw;
        --image: 100%;
        @media (min-width: ${R.md}) {
          --height: 100%;
          --image: 50%;
          --graphic-offset: 0%;
        }
      `,
      ...o,
      renderBackgroundImage: t ? () => /* @__PURE__ */ w(
        d,
        {
          baseImage: t == null ? void 0 : t.baseImage,
          mdImage: t == null ? void 0 : t.mdImage,
          imageAltText: t == null ? void 0 : t.imageAltText,
          loading: t == null ? void 0 : t.loading,
          fetchPriority: t == null ? void 0 : t.fetchPriority,
          imageServerKnobs: t == null ? void 0 : t.imageServerKnobs,
          css: h`
                  background: var(--color-primary);
                  .image-parallax-frame-inner {
                    ${e}
                  }
                `,
          ariaHidden: s
        }
      ) : void 0
    }
  );
};
v.displayName = g;
const W = (i) => i === "Start" ? {
  // IMAGE LEFT
  graphicVersion: "SplitLeftLarge",
  imageRightPosition: !1
} : {
  // IMAGE RIGHT
  graphicVersion: "SplitRightLarge",
  imageRightPosition: !0
}, E = (i) => i === "WhiteOnBlue600" ? "blue 600" : "white", n = (i = "regular", s) => {
  const o = i === "compact" ? {
    topSpacing: "6vw",
    bottomSpacing: "6vw",
    rowsGap: "value",
    rowsGapValue: "2vw"
  } : {
    topSpacing: "8vw",
    bottomSpacing: "8vw",
    rowsGap: "value",
    rowsGapValue: "4vw"
  }, e = i === "compact" ? {
    topSpacing: "4vw",
    bottomSpacing: "4vw",
    rowsGap: "value",
    rowsGapValue: "6vw"
  } : {
    topSpacing: "6vw",
    bottomSpacing: "6vw",
    rowsGap: "value",
    rowsGapValue: "8vw"
  }, t = i === "compact" ? {
    topSpacing: "2vw",
    bottomSpacing: "2vw",
    rowsGap: "value",
    rowsGapValue: "6vw"
  } : {
    topSpacing: "4vw",
    bottomSpacing: "4vw",
    rowsGap: "value",
    rowsGapValue: "8vw"
  };
  return s === "md" ? e : s === "xl" ? t : o;
};
const m = "SplitGraphicSection", r = new S(m), K = ({
  textGroup: i,
  foregroundMediaFrame: s,
  mediaSize: o = "1:1 Large",
  backgroundMediaFrame: e,
  imagePosition: t = "End",
  graphicColor: a = "GoldOnWhite",
  componentId: G
}) => {
  const { foundationGrid: p } = B($), { graphicVersion: u, imageRightPosition: f } = W(t), x = E(a), N = n(p), c = n(
    p,
    "md"
  ), O = n(
    p,
    "xl"
  ), y = P(
    r.getComponentClassName(),
    r.getPropsValueClassName("imagePosition", t),
    r.getElementClassName("mobile-spacing")
  ), V = (s == null ? void 0 : s.type) === "Image" && (e == null ? void 0 : e.type) === "Image";
  return /* @__PURE__ */ C(
    j,
    {
      theme: x,
      options: N,
      mdOptions: c,
      lgOptions: c,
      xlOptions: O,
      className: y,
      id: G,
      children: [
        /* @__PURE__ */ l(
          A,
          {
            textGroup: i,
            mediaFrame: s,
            mediaSize: o,
            imageRightPosition: f,
            gridRow: 1,
            analyticsCompName: m
          }
        ),
        /* @__PURE__ */ l(
          v,
          {
            graphicColor: a,
            graphicVersion: u,
            backgroundAsset: e,
            ariaHidden: V
          }
        )
      ]
    }
  );
};
K.displayName = m;
export {
  K as default
};
//# sourceMappingURL=SplitGraphicSectionType.js.map
